// extracted by mini-css-extract-plugin
export default {"pageTitle":"Currently_pageTitle__e5q9k","currentWeek":"Currently_currentWeek__+B9Ub"};